export const hospitalHimCptCategoriesColumns = [
  'id',
  'r1_id',
  'revint_id',
  'account_number',
  'apc_payment',
  'category_id',
  'category_name',
  'si',
];
